// ================================
// common
// ================================
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import ErrorSession from "@/general/components/errors/ErrorSession.vue";
import ErrorAuth from "@/general/components/errors/ErrorAuth.vue";
import ErrorNotFound from "@/general/components/errors/error-404.vue";

// ================================
// cms
// ================================
import CmsHeaderSearch from "@/general/components/pages/CmsHeaderSearch.vue";

// ================================
// components
// ================================
import Loading from "@/general/components/Loading.vue";
import LoadingProcess from "@/general/components/LoadingProcess.vue";
import LoadingContent from "@/general/components/LoadingContent.vue";
import LoadingPage from "@/general/components/LoadingPage.vue";
import Carousel2 from "@/general/components/carousels/Carousel2.vue";
import FloatingGivePointButton from "@/general/components/organisms/FloatingGivePointButton.vue";
// ================================
// components commons
// ================================
import Button from "@/common/components/atoms/Button.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import ButtonLink from "@/common/components/atoms/ButtonLink.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import PageNavi from "@/common/components/atoms/PageNavi.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";

import FirstLoginModal from "@/general/components/pages/FirstLogin.vue";
import { App } from "vue";

export default function registerGlobalComponents(app: App) {
  // ================================
  // common
  // ================================
  app.component("TheHeader", TheHeader);
  app.component("TheFooter", TheFooter);
  app.component("ErrorSession", ErrorSession);
  app.component("ErrorAuth", ErrorAuth);
  app.component("ErrorNotFound", ErrorNotFound);

  // ================================
  // cms
  // ================================
  app.component("CmsHeaderSearch", CmsHeaderSearch);

  // ================================
  // components
  // ================================
  app.component("LoadingProcess", LoadingProcess);
  app.component("AppLoading", Loading);
  app.component("LoadingContent", LoadingContent);
  app.component("LoadingPage", LoadingPage);
  app.component("AppCarousel2", Carousel2);
  app.component("FloatingGivePointButton", FloatingGivePointButton);

  // ================================
  // components commons
  // ================================
  app.component("BaseButton", Button);
  app.component("ButtonMain", ButtonMain);
  app.component("ButtonLink", ButtonLink);
  app.component("PageNavi", PageNavi);
  app.component("CommonHeading", CommonHeading);
  app.component("TheBreadcrumb", TheBreadcrumb);

  app.component("FirstLoginModal", FirstLoginModal);
}
